// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import React, { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';
import { Box, useTheme } from '@mui/system';
import { useAppDispatch } from 'Hooks';
import { Auth0Login } from '../authActions';
import stylesDef from './styles';

const Auth0Callback = () => {
  const { isAuthenticated, user, isLoading, getAccessTokenSilently, error } = useAuth0();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = stylesDef(theme);

  useEffect(() => {
    if (isAuthenticated && user && !isLoading) {
      const processAuth0Login = async () => {
        try {
          const auth0Token = await getAccessTokenSilently();

          await dispatch(Auth0Login({
            auth0Token,
            userInfo: user,
          })).unwrap();

          navigate('/projects');
        } catch (error) {
          navigate('/', { state: { auth0Error: error.message } });
        }
      };

      processAuth0Login();
    } else if (!isLoading && !isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, user, isLoading, getAccessTokenSilently, dispatch, navigate]);

  return (
    <Box sx={styles.container}>
      <div>Completing authentication...</div>
    </Box>
  );
};

export default Auth0Callback;
